import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import CustomToastContainer from "../../Common/CustomToastContainer";
import axios from "axios";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const Footer = () => {
  const toastRef = useRef();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toastRef.current.addToast("Please enter your email.", "warning");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${domainpath}/api/newsletter`, { email });
      toastRef.current.addToast(
        "You've been subscribed to the newsletter!",
        "success"
      );
      setEmail("");
    } catch (error) {
      const message =
        error.response?.data?.error || "Something went wrong. Try again.";
      toastRef.current.addToast(message, "danger");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <footer className="footer-light">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-6 col-xs-1">
              <div className="widget">
                <h5>Marketplace</h5>
                <ul>
                  <li>
                    <Link to="">All NFTs</Link>
                  </li>
                  <li>
                    <Link to="">Images</Link>
                  </li>
                  <li>
                    <Link to="">Video</Link>
                  </li>
                  <li>
                    <Link to="">Audios</Link>
                  </li>
                  <li>
                    <Link to="">Gif</Link>
                  </li>
                  <li>
                    <Link to="/create-collection">Collections</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-1">
              <div className="widget">
                <h5>Resources</h5>
                <ul>
                  <li>
                    <Link to="">Help Center</Link>
                  </li>
                  <li>
                    <Link to="">Partners</Link>
                  </li>
                  <li>
                    <Link to="">Suggestions</Link>
                  </li>
                  <li>
                    <Link to="">Discord</Link>
                  </li>
                  <li>
                    <Link to="">Docs</Link>
                  </li>
                  <li>
                    <Link to="">Newsletter</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-1">
              <div className="widget">
                <h5>Community</h5>
                <ul>
                  <li>
                    <Link to="">Community</Link>
                  </li>
                  <li>
                    <Link to="">Documentation</Link>
                  </li>
                  <li>
                    <Link to="">Brand Assets</Link>
                  </li>
                  <li>
                    <Link to="https://medium.com/@teamartcollect">Blog</Link>
                  </li>
                  <li>
                    <Link to="">Forum</Link>
                  </li>
                  <li>
                    <Link to="">Mailing List</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-1">
              <div className="widget">
                <h5>Newsletter</h5>
                <p>
                  Signup for our newsletter to get the latest news in your
                  inbox.
                </p>
                <form
                  action="#"
                  className="row form-dark"
                  id="form_subscribe"
                  method="post"
                  name="form_subscribe"
                  onSubmit={handleSubscribe}
                >
                  <div className="col text-center">
                    <input
                      className="form-control"
                      id="txt_subscribe"
                      name="txt_subscribe"
                      placeholder="enter your email"
                      type="text"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div to="" id="btn-subscribe" onClick={handleSubscribe}>
                      <i className="arrow_right bg-color-secondary"></i>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </form>
                <div className="spacer-10"></div>
                <small>Your email is safe with us. We don't spam.</small>
              </div>
            </div>
          </div>
        </div>
        <div className="subfooter">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="de-flex">
                  <div className="de-flex-col">
                    <span onClick={() => window.open("", "_self")}>
                      <span className="copy">
                        &copy; Copyright 2025 - Art Collect by NFT Freaks
                      </span>
                    </span>
                  </div>
                  <div className="de-flex-col">
                    <div className="social-icons">
                      <span onClick={() => window.open("", "_self")}>
                        <i className="fa fa-facebook fa-lg"></i>
                      </span>
                      <span onClick={() => window.open("", "_self")}>
                        <i className="fa fa-twitter fa-lg"></i>
                      </span>
                      <span onClick={() => window.open("", "_self")}>
                        <i className="fa fa-linkedin fa-lg"></i>
                      </span>
                      <span onClick={() => window.open("", "_self")}>
                        <i className="fa fa-pinterest fa-lg"></i>
                      </span>
                      <span onClick={() => window.open("", "_self")}>
                        <i className="fa fa-rss fa-lg"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};
export default Footer;
